module.exports = __webpack_public_path__ + "static/media/18-6.2b3794bd.mp3";